import { makeStyles } from '@material-ui/core/styles';
import { Unit } from 'api/generated';
import { FC } from 'react';
import { DeleteButton, SaveButton, Toolbar, ToolbarProps } from 'react-admin';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const UnitsToolbar: FC<ToolbarProps> = (props) => {
  const analysisKindRecord = props.record as Unit;
  const { name } = analysisKindRecord;
  return (
    <Toolbar {...props} classes={useStyles()}>
      <SaveButton label="Save" disabled={props.pristine} />
      <DeleteButton
        confirmTitle="Unit remove"
        confirmContent={`Are you sure you want to delete item "${name}"?`}
        label="Remove"
        mutationMode="optimistic"
      />
    </Toolbar>
  );
};
